/**
 * elopementRisk.js
 *
 * @description Dismiss Elopement Risks
 */

import { SVC_A } from './base.js'
import queryString from 'query-string'

/**
 * Dismiss a given alert, by UUID, secured with a pin.
 *
 * @export
 * @param {String} uuid The UUID of the alert to dismiss.
 * @param {String} pin The PIN of the user performing the dismissal.
 */
export function dismissAlertWithPin (alertId, userPIN) {
  return SVC_A.post(`/api/faces/v1/alerts/${alertId}/dismiss`, { userPIN })
}

/**
 * Acknowledge All: dismiss several residents' alerts with one PIN entry.
 *
 * @export
 * @param {String} domainUUID The domain the alerts belong to.
 * @param {Array<String>} alertIds One alert id per resident; each dismisses all of that resident's open alerts.
 * @param {String} userPIN The hashed PIN of the user, or 'me' when the role doesn't require a PIN.
 */
export function dismissAllAlertsWithPin (domainUUID, alertIds, userPIN) {
  return SVC_A.post('/api/faces/v1/alerts/dismiss_all', { domainUUID, alertIds, userPIN })
}

/**
 * Fetches the events in the domain.
 *
 * @export
 * @param {string} domainUUID The domain to fetch against
 * @param {string} since A timestamp defining the earliest possible event.
 * @param {string} before A timestamp defining the latest possible event.
 * @param {number} offset A SQL offset
 * @param {number} limit A SQL limit
 * @param {string} sort Either 'ascending' or 'descending'. If no value or an invalid value, `ASC` is used.
 * @param {boolean} dismissed Include dismissed?
 * @returns
 */
export function fetchFacesAlerts ({
  domainUUID,
  since,
  before,
  offset,
  limit,
  sort,
  includeDismissed,
} = {}) {
  const query = queryString.stringify({
    domainUUID,
    since,
    before,
    offset,
    limit,
    sort,
    include_dismissed: includeDismissed,
  })
  return SVC_A.get(`/api/faces/v1/alerts?`, query)
}
